import React from 'react'
import ProductCard from './ProductCard'

function BuyAKit({ kit }) {

    return (
        <>
        <h2 className="normal-case text-white font-bold text-4xl text-center py-8">Buy A Kit</h2>
            <ProductCard product={kit} kit={true} extraClasses='lg:max-w-2xl lg:m-auto' />
        </>
    )
}

export default BuyAKit